module.exports = __webpack_public_path__ + "static/media/fingerprintGrey.d067befe.svg";